module.exports = __webpack_public_path__ + "img/sensitive_bg.5a48e998.png";